import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OrderDeclineType } from 'types/enums/OrderDeclineType';
import { OrderStatus } from 'types/enums/OrderStatus';

type OneClickPaymentState = {
  status: OrderStatus | null;
  cardToken: string | null;
  cardMask: string | null;
  declineType: OrderDeclineType | null;
  verifyUrl: string | null;
  orderId: string | null;
};

const initialState: OneClickPaymentState = {
  status: null,
  cardToken: null,
  cardMask: null,
  declineType: null,
  verifyUrl: null,
  orderId: null,
};

const oneClickPaymentSlice = createSlice({
  name: 'oneClickPayment',
  initialState,
  reducers: {
    reset(state) {
      state.status = null;
      state.cardToken = null;
      state.cardMask = null;
      state.declineType = null;
      state.verifyUrl = null;
      state.orderId = null;
    },
    setStatus(state, action: PayloadAction<OrderStatus | null>) {
      state.status = action.payload;
    },
    setCardToken(state, action: PayloadAction<string | null>) {
      state.cardToken = action.payload;
    },
    setCardMask(state, action: PayloadAction<string | null>) {
      state.cardMask = action.payload;
    },
    setDeclineType(state, action: PayloadAction<OrderDeclineType | null>) {
      state.declineType = action.payload;
    },
    setVerifyUrl(state, action: PayloadAction<string | null>) {
      state.verifyUrl = action.payload;
    },
    setOrderId(state, action: PayloadAction<string | null>) {
      state.orderId = action.payload;
    },
  },
});

export const {
  reset: oneClickPaymentReset,
  setStatus: setOneClickPaymentStatus,
  setCardToken: setOneClickPaymentCardToken,
  setCardMask: setOneClickPaymentCardMask,
  setDeclineType: setOneClickPaymentDeclineType,
  setVerifyUrl: setOneClickPaymentVerifyUrl,
  setOrderId: setOneClickPaymentOrderId,
} = oneClickPaymentSlice.actions;

export const oneClickPayment = oneClickPaymentSlice.reducer;
